export default "__VITE_ASSET__rkeTjR_d__"